import React from 'react'
import { useTranslation } from 'react-i18next'

import { RequestTicketStatusSync } from 'src/types'

import { StyledIcon } from './styles'

export function SyncStatusBadge({ status = null }: { status: any }) {
  const { t } = useTranslation()
  switch (status) {
    // case RequestTicketStatusSync.NOT_SYNC:
    //   return <></>
    case RequestTicketStatusSync.SYNC:
      return <StyledIcon title={t('common.sync.SYNC')} type="cloud" />
    case RequestTicketStatusSync.END_SYNC:
      return (
        <StyledIcon
          color="#278c0c"
          title={t('common.sync.END_SYNC')}
          type="cloud-upload"
        />
      )
    default:
      return <></>
  }
}
